<template>
  <div class="modal_wrap">
    <div class="modal">
      <a @click="closeModal" class="modal_close"></a>
      <div class="modal_header">
          <div class="title">주문비밀번호 찾기</div>
          <p class="txt">비회원 주문비밀번호 찾기</p>
      </div>
      <div class="modal_body">
          <div class="member not">
              <div class="form_wrap">
                  <p class="title">주문자명</p>
                  <input type="text" placeholder="주문자명을 입력해주세요.">
              </div>
              <div class="form_wrap">
                  <p class="title">휴대폰 번호</p>
                  <input type="number" id="tel1" maxlength="3" required>
                  <span class="hyphen">-</span>
                  <input type="number" id="tel2" maxlength="4" required>
                  <span class="hyphen">-</span>
                  <input type="number" id="tel3" maxlength="4" required>
                  <button>본인인증</button>
              </div>
              <div class="form_wrap">
                  <p class="title">비밀번호 받기</p>
                  <label for="email" class="radio_wrap">
                      <input type="radio" id="email" name="passType">
                      <span>이메일</span>
                  </label>
                  <label for="sms" class="radio_wrap">
                      <input type="radio" id="sms" name="passType">
                      <span>SMS</span>
                  </label>
              </div>
              <p class="txt_box">
                  주문 시 입력한 이메일 주소 또는 휴대폰 번호로 임시 비밀번호를 보내 드립니다.<br>
                  전송 받기 불가시 고객센터로 문의바랍니다.
              </p>
              <button type="button" class="btn_receive">전송받기</button>
          </div>
      </div>
    </div>   
  </div>
</template>
<script>
export default {
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>
<style lang="">
    
</style>